import { render } from "./Dashboard.vue?vue&type=template&id=2040ac39&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=2040ac39&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2040ac39"

export default script